module.exports = __webpack_public_path__ + "static/projekt-opakowania-suplement-diety-9045462fb67a214733ea324cdb324854.jpg";